export default "__VITE_ASSET__DJVGL2RG__"